import { RequestAQuoteState, TActionRequestAQuote } from "@/models/store";
import { getDefaultRequestAQuoteState } from "@/utils/common/store";

export const reducerRequestAQuote = (
    state: RequestAQuoteState,
    action: TActionRequestAQuote
): RequestAQuoteState => {
    switch (action.type) {
        case "SET_REQUEST_A_QUOTE":
            return { ...state, ...action.payload };
        case "RESET_REQUEST_A_QUOTE":
            return getDefaultRequestAQuoteState();
        default:
            return state;
    }
};
